var loadFile = function (event) {
  var preview = document.querySelector('.preview-file')
  var output = document.getElementById('preview')
  output.src = URL.createObjectURL(event.target.files[0])
  preview.style.display = 'flex'
  document.getElementById('file-label').style.display = 'none'
  document.getElementById('upload-file-label').style.display = 'none'
}

var acceptPhoto = function () {
  var preview = document.querySelector('.preview-file')
  preview.style.display = 'none'
  document.getElementById('file-label').style.display = 'none'
  document.getElementById('upload-file-label').style.display = 'none'
  var output = document.getElementById('preview-small')
  output.src = document.getElementById('preview').src
  output.style.display = 'block'
  document.getElementById('file-label').classList.remove('error-btn')
  document.getElementById('upload-file-label').classList.remove('error-btn')
  document.getElementById('no-file-added-error').style.display = 'none'
}

var retakePhoto = function () {
  var preview = document.querySelector('.preview-file')
  preview.style.display = 'none'
  var file = document.getElementById('file')
  file.value = ''
  document.getElementById('file').click()
}

var testInputEl = document.createElement('input')
var supported = testInputEl.capture != undefined

if (!supported) {
  document.getElementById('file-label').style.display = 'none'; // Hide the file input field if not a desktop or camera is not supported
}


const termsLink = document.getElementById('terms-link');
const tncLink = document.getElementById('tnc-link');
const closeBtn = document.getElementById('closeBtn');
const popup = document.getElementById('popup');

termsLink.addEventListener('click', () => {
  popup.style.display = 'block';
});
tncLink.addEventListener('click', () => {
  popup.style.display = 'block';
});

// Close the popup if click outside the popup
window.addEventListener('click', (e) => {
  if (e.target === popup) {
    popup.style.display = 'none';
  }
});

closeBtn.addEventListener('click', () => {
  popup.style.display = 'none';
});

function postDocumentHeight() {
  if(window.parent.postMessage){
    window.parent.postMessage(
      {
        height: document.body.scrollHeight
      }, "https://www.carmexnordic.com/");
    }
}
window.onload = function(e){ 
  setTimeout(() => {
    postDocumentHeight();
  }, 500);
}